module.exports = __webpack_public_path__ + "img/interactivePro_logo.aa8b97ac.png";